import { TMouseOrTouchEvent } from '../types';

/** @description Возвращает флаг является ли событие касанием на тачскрине
 * @param event {TMouseOrTouchEvent} объект события мыши или тач нажатия
 * @return {boolean}
 */

export function isTouchEvent(event: TMouseOrTouchEvent): event is TouchEvent {
  return 'changedTouches' in event;
}
